export type KeypadKey = "0" | "1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | "9" | "00" | "." | "back" | "clear";

const MAX_INTEGER_DIGITS = 7;

/**
 * Applies one keypad press to a money string. Keeps at most one decimal point and two
 * decimals, strips leading zeros, and caps the integer part so a stuck key can't run away.
 */
export function applyKeypadKey(current: string, key: KeypadKey): string {
  const value = current ?? "";

  if (key === "clear") return "";
  if (key === "back") return value.slice(0, -1);

  if (key === ".") {
    if (value.includes(".")) return value;
    return value === "" ? "0." : `${value}.`;
  }

  const [intPart, decPart] = value.split(".");
  const hasDot = value.includes(".");

  if (hasDot) {
    if ((decPart ?? "").length >= 2) return value;
    const room = 2 - (decPart ?? "").length;
    return `${intPart}.${(decPart ?? "") + key.slice(0, room)}`;
  }

  let next = intPart + key;
  next = next.replace(/^0+(?=\d)/, "");
  if (next.length > MAX_INTEGER_DIGITS) return value;

  return next;
}

/** The keypad string as a number, or 0 when empty / a lone dot. */
export function keypadValue(current: string): number {
  const n = parseFloat(current);
  return Number.isFinite(n) ? n : 0;
}
